<template>
  <div v-if="backupPlusOffer" class="flex flex-col gap-12 md:flex-row">
    <BackupPlusOfferSet
      :id
      :backup-plus-offer
      :offers="filteredOffers"
      :selected-offer-id
      :tracking-zone
      @remove="emit('remove')"
      @select="(offer) => emit('select', offer)"
    />
  </div>

  <div v-else class="flex flex-col gap-12 md:flex-row">
    <InsuranceRadio
      v-for="(offer, index) in filteredOffers"
      :id="createIdentifier(offer.id)"
      :key="createIdentifier(offer.id)"
      class="pt-10 only-of-type:w-full"
      :data-qa="`insurance-offer-${index}`"
      :is-highlighted="index === 0"
      :is-selected="selectedOfferId === offer.id"
      :offer
      :tag-props="
        useInsuranceTagProps(filteredOffers, index, market.countryCode)
      "
      :tracking-zone
      @remove="emit('remove')"
      @select="emit('select', offer)"
    >
    </InsuranceRadio>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { InsuranceOffer } from '@backmarket/http-api'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useInsuranceTagProps } from '~/scopes/checkout/composables/useInsuranceTagProps'

import { DEFAULT_INSURANCE_ID } from '../../constants'

import BackupPlusOfferSet from './components/BackupPlusOfferSet/BackupPlusOfferSet.vue'
import InsuranceRadio from './components/InsuranceRadio/InsuranceRadio.vue'

const { market } = useMarketplace()

const props = defineProps<{
  offers: InsuranceOffer[]
  trackingZone: string
  id: string
  selectedOfferId?: number | string
}>()

const emit = defineEmits<{
  select: [insuranceOffer: InsuranceOffer]
  remove: []
}>()

// Will be remove in B2CS-XXX
const filteredOffers = computed(() => {
  return props.offers.filter(
    (offer) =>
      !offer.isCatchUpOffer && offer.id.toString() !== DEFAULT_INSURANCE_ID,
  )
})

const backupPlusOffer = computed(() => {
  return filteredOffers.value.find((offer) => offer.isBackupPlus)
})

function createIdentifier(offerId: number | string) {
  return props.id + offerId
}
</script>
